import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { formatApiError } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    document.title = 'Reset Password | Toronto Royale Admin';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(formatApiError(err.response.data.detail));
      } else if (err.request) {
        setError('Cannot reach the server. Please try again.');
      } else {
        setError(err.message || 'Something went wrong.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="admin-forgot-password-page" style={{ minHeight: '100vh', backgroundColor: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 50% 30%, rgba(194,168,120,0.06) 0%, transparent 60%)', pointerEvents: 'none' }} />

      <form onSubmit={handleSubmit} data-testid="admin-forgot-password-form" style={{ width: '100%', maxWidth: '420px', position: 'relative', zIndex: 10, backgroundColor: 'rgba(14,14,14,0.6)', border: '1px solid rgba(194,168,120,0.1)', padding: '56px 44px', backdropFilter: 'blur(12px)', boxShadow: '0 24px 80px rgba(0,0,0,0.5)' }}>
        <div style={{ position: 'absolute', top: 0, left: '15%', right: '15%', height: '1px', background: 'linear-gradient(90deg, transparent, rgba(194,168,120,0.35), transparent)' }} />
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <p style={{ fontSize: '10px', color: 'rgba(194,168,120,0.6)', letterSpacing: '5px', textTransform: 'uppercase', fontWeight: 300, marginBottom: '14px' }}>Toronto Royale</p>
          <h1 className="font-serif" style={{ fontSize: '24px', fontWeight: 500, color: '#FAFAFA', letterSpacing: '0.5px', marginBottom: '14px' }}>Reset Password</h1>
          <p style={{ fontSize: '13px', color: 'rgba(225,225,225,0.8)', lineHeight: 1.6 }}>
            Enter the admin email and we'll send a one-hour reset link.
          </p>
        </div>

        {submitted ? (
          <div data-testid="admin-forgot-password-success" style={{ padding: '20px 22px', backgroundColor: 'rgba(120,180,140,0.08)', border: '1px solid rgba(120,180,140,0.3)', color: '#88C99F', fontSize: '13px', lineHeight: 1.7 }}>
            <p style={{ marginBottom: '10px', fontWeight: 500 }}>Check your inbox.</p>
            <p style={{ color: 'rgba(204,204,204,0.65)' }}>If an account exists for that email, we just sent a reset link valid for the next hour.</p>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontSize: '11px', color: 'rgba(194,168,120,0.7)', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px', fontWeight: 400 }}>Email</label>
              <input
                data-testid="admin-forgot-password-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                style={{ width: '100%', backgroundColor: 'rgba(8,8,8,0.7)', border: '1px solid rgba(194,168,120,0.15)', color: '#F5F5F5', padding: '13px 16px', fontSize: '14px', outline: 'none' }}
              />
            </div>

            {error && (
              <div data-testid="admin-forgot-password-error" style={{ marginBottom: '18px', padding: '11px 13px', backgroundColor: 'rgba(180,40,40,0.08)', border: '1px solid rgba(220,80,80,0.25)', color: '#E89B9B', fontSize: '12px' }}>
                {error}
              </div>
            )}

            <button
              data-testid="admin-forgot-password-submit"
              type="submit"
              disabled={submitting}
              style={{ width: '100%', padding: '14px', backgroundColor: '#C2A878', color: '#0A0A0A', fontSize: '12px', fontWeight: 600, letterSpacing: '2px', textTransform: 'uppercase', border: 'none', cursor: submitting ? 'wait' : 'pointer', opacity: submitting ? 0.6 : 1, transition: 'all 200ms ease' }}
            >
              {submitting ? 'Sending…' : 'Send Reset Link'}
            </button>
          </>
        )}

        <div style={{ marginTop: '24px', textAlign: 'center' }}>
          <Link to="/admin/login" data-testid="admin-back-to-login" style={{ fontSize: '12px', color: 'rgba(194,168,120,0.7)', textDecoration: 'none', letterSpacing: '0.5px' }}>
            &larr; Back to login
          </Link>
        </div>
      </form>
    </div>
  );
};
